/* CAFFREY Stainless Steel Shoe Horn — page behaviour (launch build, Claude Code, 2026-10-08).
   <cf-ssh-page>   five length pills -> the main form's hidden [name=id] (+ bubbling change event for the kit sticky bar and
                   Shopify's Shop Pay button), price ("From …" until a length is chosen), ?variant= URL. NOTHING is
                   preselected (the wrong length is the category's top regret): until a length is chosen, Add to cart,
                   Shop Pay (a transparent guard over Shopify's greyed button) and the kit sticky bar ("Choose your length"
                   with an active Add to cart) show "Choose your length first." under the label and bring the pills into view.
                   Gallery: scroll-snap slides; dots (phone/tablet) and thumbnails (desktop) follow the visible slide.
   <cf-ssh-ladder> the steel ladder: a tap chooses that length in the buy box and brings the buy box back; the chosen bar
                   is marked; the bars rise once on first view (only under prefers-reduced-motion: no-preference).
   <cf-ssh-why>    the drawn heel eases down the blade once when 40% of the drawing is in view (same motion rule).
   No dependencies. Dawn's <product-form> does the AJAX add and the cart notification. */
(function () {
  'use strict';
  var arr = function (list) { return Array.prototype.slice.call(list || []); };
  var reduced = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
  var behaviour = function () { return reduced() ? 'auto' : 'smooth'; };
  var designMode = function () { return !!(window.Shopify && window.Shopify.designMode); };

  if (!customElements.get('cf-ssh-page')) {
    class CfSshPage extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        this.gallery();
        this.form = document.getElementById(this.dataset.form);
        this.idInput = this.form ? this.form.querySelector('[data-ssh-id]') : null;
        this.atc = this.form ? this.form.querySelector('[data-cf-atc]') : null;
        this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
        this.radios = arr(this.querySelectorAll('input[data-ssh-length]'));
        this.group = this.querySelector('[data-ssh-pick]');
        this.msg = this.querySelector('[data-ssh-ask]');
        this.prices = arr(this.querySelectorAll('[data-ssh-price]'));
        this.guard = this.querySelector('[data-ssh-pay-guard]');
        if (!this.form || !this.idInput || !this.atc || !this.radios.length) return;
        this.idInput.disabled = false; /* disabled in the HTML so no-JS shoppers use the <noscript> select */
        this.addEventListener('change', function (e) {
          if (e.target.matches && e.target.matches('input[data-ssh-length]')) self.select(e.target, true);
        });
        /* Capture phase on an ancestor of the form: runs before Dawn's <product-form> submit handler on the form. */
        this.addEventListener('submit', function (e) {
          if (e.target !== self.form || self.current()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.askFirst();
        }, true);
        if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.askFirst(); });
        /* Keyboard users can still reach Shopify's "More payment options" link under the guard: with no length chosen, a
           click anywhere in the payment block asks for a length instead. */
        var pay = this.querySelector('[data-ssh-pay]');
        if (pay) {
          pay.addEventListener('click', function (e) {
            if (self.current() || (e.target.closest && e.target.closest('[data-ssh-pay-guard]'))) return;
            e.preventDefault();
            e.stopPropagation();
            self.askFirst();
          }, true);
        }
        window.addEventListener('pageshow', function () { self.sync(); });
        this.sync();
        this.watchSticky();
        this.dataset.ready = 'true';
      }

      current() {
        for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked && !this.radios[i].disabled) return this.radios[i];
        return null;
      }

      firstAvailable() {
        for (var i = 0; i < this.radios.length; i++) if (this.radios[i].getAttribute('data-available') === 'true' && !this.radios[i].disabled) return this.radios[i];
        return null;
      }

      sync() {
        var r = this.current();
        if (r) this.select(r, false); else this.none();
      }

      setId(value) {
        if (this.idInput && this.idInput.value !== value) {
          this.idInput.value = value;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      setPrice(text) {
        if (!text) return;
        this.prices.forEach(function (el) { if (el.textContent !== text) el.textContent = text; });
      }

      none() {
        var any = !!this.firstAvailable();
        this.setId('');
        this.setPrice(this.dataset.from);
        this.atc.disabled = !any;
        if (this.atcLabel) this.atcLabel.textContent = any ? this.dataset.add : this.dataset.soldOut;
        if (this.guard) this.guard.hidden = !any;
        this.patchSticky();
        this.emit('');
      }

      select(r, byUser) {
        var ok = r.getAttribute('data-available') === 'true';
        this.setId(r.value);
        this.setPrice(r.getAttribute('data-price'));
        this.atc.disabled = !ok;
        if (this.atcLabel) this.atcLabel.textContent = ok ? this.dataset.add : this.dataset.soldOut;
        if (this.guard) this.guard.hidden = true;
        this.clearAsk();
        this.patchSticky();
        if (byUser && !designMode() && window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', r.value);
            history.replaceState(history.state, '', u.toString());
          } catch (err) { /* ignore */ }
        }
        this.emit(r.value);
      }

      emit(id) {
        document.dispatchEvent(new CustomEvent('cf-ssh:length', { detail: { id: id } }));
      }

      /* Called by the steel ladder: choose a length by variant id and bring the buy box back into view. */
      choose(id, scroll) {
        var r = this.radios.find(function (x) { return x.value === String(id); });
        if (!r || r.disabled) return false;
        r.checked = true;
        this.select(r, true);
        if (scroll && this.group) {
          var target = this.querySelector('.cf-ssh-buy') || this.group;
          target.scrollIntoView({ behavior: behaviour(), block: 'center' });
          try { r.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
        }
        return true;
      }

      /* "Choose your length first." sits between the label and the pills; the label, message and pills come into view
         together (under the store's sticky-on-scroll-up header, above any short bottom overlay); first length focused. */
      askFirst() {
        var st = document.querySelector('cf-kit-sticky');
        if (st && typeof st.done === 'function') st.done();
        var first = this.firstAvailable();
        if (!first) return;
        var msg = this.dataset.chooseFirst;
        var el = this.msg;
        if (el) {
          var again = !el.hidden && el.textContent === msg;
          el.hidden = false;
          el.classList.remove('is-on');
          void el.offsetWidth;
          el.classList.add('is-on');
          if (again) {
            el.textContent = ' ';
            setTimeout(function () { el.textContent = msg; }, 80);
          } else {
            el.textContent = msg;
          }
        }
        if (this.group) {
          this.group.classList.remove('is-asking');
          void this.group.offsetWidth;
          this.group.classList.add('is-asking');
          this.group.setAttribute('aria-invalid', 'true');
        }
        this.reveal();
        try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
      }

      reveal() {
        var box = this.group;
        if (!box) return;
        var r = box.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var hdr = document.querySelector('sticky-header');
        var head = hdr ? Math.min(Math.round(hdr.getBoundingClientRect().height), 160) : 0;
        var over = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cf-bottom-overlay')) || 0;
        var top = head + 12;
        var bottom = Math.min(over, 160) + 12;
        if (r.top >= top && r.bottom <= vh - bottom) return;
        window.scrollTo({ top: Math.max(0, Math.round(window.pageYOffset + r.top - top)), behavior: behaviour() });
      }

      clearAsk() {
        if (this.msg && !this.msg.hidden) { this.msg.hidden = true; this.msg.textContent = ''; this.msg.classList.remove('is-on'); }
        if (this.group) { this.group.classList.remove('is-asking'); this.group.removeAttribute('aria-invalid'); }
      }

      /* The kit sticky bar (shared) mirrors the form's id: with none it would read "Unavailable" with a disabled button.
         With nothing chosen it reads "Choose your length" (no price: it would be cut off on phones), and its Add to cart
         presses the main button (which asks for a length). Once a length is chosen it shows "24 inches · price". */
      watchSticky() {
        var self = this;
        var tries = 0;
        var attach = function () {
          var st = document.querySelector('cf-kit-sticky');
          if (!st) { if (++tries < 40) setTimeout(attach, 250); return; }
          if (self._stObs) return;
          self._st = st;
          self._stObs = new MutationObserver(function () { self.patchSticky(); });
          self._stObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
          self.patchSticky();
        };
        attach();
      }

      patchSticky() {
        var st = this._st;
        if (!st) return;
        var btn = st.querySelector('[data-cf-sticky-atc]');
        var label = btn ? btn.querySelector('span') : null;
        var v = st.querySelector('[data-cf-sticky-variant]');
        var p = st.querySelector('[data-cf-sticky-price]');
        var sep = v && v.nextElementSibling && v.nextElementSibling !== p ? v.nextElementSibling : null;
        var r = this.current();
        if (r) {
          var want = r.getAttribute('data-label') || '';
          if (v && want && v.textContent !== want) v.textContent = want;
          if (p && p.hidden) p.hidden = false;
          if (sep && sep.hidden) sep.hidden = false;
          return; /* availability and price: the kit's own sync */
        }
        if (!this.firstAvailable()) return; /* nothing available: keep the kit's sold-out state */
        if (btn && btn.disabled) btn.disabled = false;
        if (label && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
        if (v && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
        /* "Choose your length" alone: a price here would be truncated on phones (the price shows once a length is chosen). */
        if (p && !p.hidden) p.hidden = true;
        if (sep && !sep.hidden) sep.hidden = true;
      }

      /* Gallery: native scroll-snap; dots and thumbnails follow the visible slide. */
      gallery() {
        var self = this;
        var t = this.querySelector('[data-ssh-track]');
        this.track = t;
        this.gos = arr(this.querySelectorAll('[data-go]'));
        if (!t) return;
        this.gos.forEach(function (b) {
          b.addEventListener('click', function () { self.goTo(Number(b.getAttribute('data-go'))); });
        });
        var raf = null;
        t.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            self.mark(Math.round(t.scrollLeft / Math.max(1, t.clientWidth)));
          });
        }, { passive: true });
      }

      goTo(i) {
        var t = this.track;
        if (!t) return;
        t.scrollTo({ left: i * t.clientWidth, behavior: behaviour() });
        this.mark(i);
      }

      mark(i) {
        this.gos.forEach(function (b) { b.setAttribute('aria-current', String(Number(b.getAttribute('data-go')) === i)); });
      }
    }
    customElements.define('cf-ssh-page', CfSshPage);
  }

  /* Arms a once-only reveal for an element that starts below the fold (never for one already on screen at load). */
  function onceInView(el, threshold, run) {
    if (reduced() || !('IntersectionObserver' in window)) return false;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.top < vh) return false;
    el.classList.add('is-armed');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.disconnect();
        run();
      });
    }, { threshold: threshold });
    io.observe(el);
    return true;
  }

  if (!customElements.get('cf-ssh-ladder')) {
    class CfSshLadder extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        this.links = arr(this.querySelectorAll('a[data-ssh-pick]'));
        this.addEventListener('click', function (e) {
          var a = e.target.closest('a[data-ssh-pick]');
          if (!a || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button > 0) return;
          var page = document.querySelector('cf-ssh-page');
          if (!page || typeof page.choose !== 'function') return;
          if (page.choose(a.getAttribute('data-ssh-pick'), true)) e.preventDefault();
        });
        document.addEventListener('cf-ssh:length', function (e) { self.mark(e.detail && e.detail.id); });
        var page = document.querySelector('cf-ssh-page');
        var cur = page && typeof page.current === 'function' && page.radios ? page.current() : null;
        if (cur) this.mark(cur.value);
        var ladder = this.querySelector('[data-ssh-ladder]');
        if (ladder) onceInView(ladder, 0.25, function () { ladder.classList.add('is-in'); });
      }

      mark(id) {
        this.links.forEach(function (a) {
          if (id && a.getAttribute('data-ssh-pick') === String(id)) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('cf-ssh-ladder', CfSshLadder);
  }

  if (!customElements.get('cf-ssh-why')) {
    class CfSshWhy extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        var art = this.querySelector('.cf-ssh-why__art') || this;
        if (onceInView(art, 0.4, function () { self.classList.add('is-in'); })) this.classList.add('is-armed');
      }
    }
    customElements.define('cf-ssh-why', CfSshWhy);
  }
})();
